/**
 * Created by work on 17/2/13.
 */
import {REFRESH_LIFE_DATA, REFRESH_LIFE_TAB, REFRESH_LIFE_EXPLAIN, REFRESH_ITEM_DATA, IN_ART_PAGE} from
  '../actions/lifeReport';

const initState = {
  lifeData: null,
  lifeTab: true,
  lifeExplain: null,
  itemData: null,
  isIn: true
};

export default (state = initState, action) => {
  switch (action.type) {
    case IN_ART_PAGE: {
      return Object.assign({}, state, {isIn: action.isIn});
    }
    case REFRESH_LIFE_DATA: {
      const {lifeData} = action;
      return Object.assign({}, state, {lifeData});
    }
    case REFRESH_LIFE_TAB: {
      return Object.assign({}, state, {lifeTab: action.lifeTab});
    }
    case REFRESH_LIFE_EXPLAIN: {
      return Object.assign({}, state, {lifeExplain: action.newExplain});
    }
    case REFRESH_ITEM_DATA: {
      return Object.assign({}, state, {itemData: action.itemData});
    }
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/reducers/lifeReport.js